export default [
    {
        path: '/fwshop',
        meta: {
        },
        component: () => import('@/views/1531/fwshop')
    },
    {
        path: "/clerk/circle",
        meta: {
            title: "店员圈子",
            menuName: '店员圈子',
            menuPermission: 'clerk_circle'
        },
        component: () => import("@/views/163/clerk/circle"),
    },
    {
        path: "/clerk/dispatchOrder/talentVideo",
        meta: {
            title: "才艺视频",
            menuName: '我的资料',
            menuPermission: 'info'
        },
        component: () => import("@/views/163/clerk/dispatchOrder/talentVideo"),
    },
]
